import ButtonCol from 'components/form-elements/ButtonCol'
import DatepickerCol from 'components/form-elements/DatepickerCol'
import Dropdown from 'components/form-elements/Dropdown'
import DropdownCol from 'components/form-elements/DropdownCol'
import InputCol from 'components/form-elements/InputCol'
import Card from 'components/ui-elements/Card'
import Row from 'components/ui-elements/Row'
import { LangLabel } from 'data/LangLabel'
import React, { Fragment, useEffect } from 'react'
import { useForm } from 'react-hook-form'

const DataSearchCard = (props) => {
    const { changeKeyword, filter, colsize, ...rest } = props
    const { setValue, register, handleSubmit, getValues, formState: { errors } } = useForm();
    const onSubmit = (reqdata) => {
        changeKeyword(reqdata)
    }

    useEffect(() => {
        const reqdata = getValues()
        changeKeyword(reqdata)
    }, [])

    return (
        <div className="col-12 mb-3">
            <form onSubmit={handleSubmit(onSubmit)}>
                <Card >
                    <Row>

                        {filter &&
                            filter.map((field) => {
                                const { dtype, name, label, colsize, value, ...restopt } = field
                                var csize = colsize ? colsize : 3
                                if (dtype && name) {
                                    switch (dtype) {
                                        case "dropdown":
                                            return <Fragment key={name}>
                                                <DropdownCol
                                                    colsize={csize}
                                                    name={name}
                                                    label={label}
                                                    register={register}
                                                    setValue={setValue}
                                                    defaultValue={value}
                                                    {...restopt}
                                                    className="form-control form-control-sm"
                                                    key={name}
                                                />
                                            </Fragment>
                                        case "divider":
                                            return <div key={name} className={`col-md-${colsize}`}></div>

                                        case "q":
                                            return <InputCol key={name} colsize={csize} name="q" setValue={setValue} register={register} label={LangLabel.LABEL_KEYWORD} placeholder={LangLabel.LABEL_PENCARIAN} className="form-control form-control-sm" />

                                        case "date":
                                            return <DatepickerCol
                                                colsize={csize}
                                                name={name}
                                                register={register}
                                                setValue={setValue}
                                                value={value}
                                                label={label}
                                                className="form-control form-control-sm"
                                                key={name}
                                            />
                                        case "hidden":
                                            return <input key={name} type="hidden" {...register(name, { value: value })} />
                                        default:
                                            return null
                                    }
                                } else {
                                    return null
                                }

                            })
                        }
                    </Row>
                    <Row>

                        <ButtonCol type="submit" className="btn btn-primary btn-sm" data-toggle="tooltip" data-container="body" title={<><i className="fa  fa-search "></i>&nbsp;&nbsp;&nbsp;{LangLabel.LABEL_SHOW}</>} />
                    </Row>
                </Card>

            </form>
        </div>
    )
}
DataSearchCard.defaultProps = {
    filter: null,
    changeKeyword: (keyword) => { }
}
export default DataSearchCard
